export default __webpack_public_path__ + "static/media/artorias--front--240.2c8f9875.jpg";